import { useMemo } from 'react';

import { hzToMhz } from '../lib/frequency.js';
import { useDeviceSettings } from './useDeviceSettings.js';

export const useDeviceFrequencyLimits = (deviceId: string) => {
  const { data: deviceSettings } = useDeviceSettings(deviceId);

  const minAllowedMhz = useMemo(() => {
    if (!deviceSettings?.minAllowedFrequency) return null;
    const mhz = hzToMhz(deviceSettings.minAllowedFrequency);
    return mhz > 0 ? mhz : null;
  }, [deviceSettings?.minAllowedFrequency]);

  const maxAllowedMhz = useMemo(() => {
    if (!deviceSettings?.maxAllowedFrequency) return null;
    const mhz = hzToMhz(deviceSettings.maxAllowedFrequency);
    return mhz > 0 ? mhz : null;
  }, [deviceSettings?.maxAllowedFrequency]);

  return { minAllowedMhz, maxAllowedMhz };
};
